import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MapHarness } from '@/features/dev/map-harness';

// /_dev/map?fixture=in-transit: the RouteMap fixtures (P5.4), laid out where
// the S04 board has its map card so the e2e can compare that region.
export const Route = createFileRoute('/_dev/map')({
  validateSearch: z.object({ fixture: z.string().optional() }),
  component: () => <MapHarness fixture={Route.useSearch().fixture ?? 'in-transit'} />,
});
